import { resolveModelDisplayName } from '@reflex/shared';
import { ModelProviderIcon } from './ModelProviderIcon';
import { EntityChip } from './EntityChip';

export interface ModelChipProps {
  /** Model id/name (e.g. `claude-3-5-sonnet`, `gpt-4o`). */
  model: string;
  /**
   * Optional display name; falls back to the `model` id resolved through
   * {@link resolveModelDisplayName}.
   */
  name?: string;
  className?: string;
  'data-testid'?: string;
}

/**
 * Standardized chip for a model selection. Shows the model's brand icon
 * (derived from the id) and name, with a hover preview resolved through the
 * `models` resource-preview kind.
 *
 * The label keeps the full id rather than shortening it — cost tables chip the
 * exact billed model — except for ids with an unreadable raw form, which
 * {@link resolveModelDisplayName} pins to their model family.
 */
export function ModelChip({ model, name, className, 'data-testid': dataTestId }: ModelChipProps) {
  return (
    <EntityChip
      kind="models"
      id={model}
      icon={<ModelProviderIcon model={model} />}
      label={name ?? resolveModelDisplayName(model)}
      className={className}
      data-testid={dataTestId}
    />
  );
}
